import React, { useId, useState } from 'react';
import { useOrg } from './OrgContext';

/*
  **Type the site's name before the thing that cannot be undone.** The owner's
  answer to the audit's question 24, 21 September 2026.

  **Why it is the SITE's name.** OnHand holds more than one, they look
  identical once you are signed in, and there is no copy of the database the
  owner can reach. The mistake this is for is not "I did not mean to press it",
  it is "I pressed it in the wrong site".

  **Where it is used, and nowhere else**: removing records past the retention
  years (Site Settings) and closing a count cycle. Both destroy records for
  good. **His words on the day, kept here because they decide what this file
  may become**: *"we may change this as I do some testing. I do not want this
  to create what I would consider extra work or an additional step on something
  that I think shouldn't need it."* So it goes on two actions rather than
  everywhere, it is one component rather than copied wording, and taking it off
  an action is deleting two lines in that dialog.

  **A site with no name yet does not lock anybody out**: if the site is not
  loaded, `ready` is true and the button behaves as it did before this existed.
*/
export function useTypeToConfirm() {
  const { current } = useOrg();
  const name = (current?.name || '').trim();
  const [typed, setTyped] = useState('');
  const id = useId();
  const ready = !name || typed.trim().toLowerCase() === name.toLowerCase();
  return {
    ready,
    name,
    field: name ? (
      <label htmlFor={id} style={{ display: 'block', marginTop: 16 }}>
        <span className="form-lbl" style={{ display: 'block', margin: 0 }}>
          Type <b style={{ color: 'var(--text-primary)' }}>{name}</b> to confirm
        </span>
        <input
          id={id}
          className="form-inp"
          value={typed}
          autoComplete="off"
          spellCheck="false"
          placeholder={name}
          onChange={e => setTyped(e.target.value)}
        />
      </label>
    ) : null,
  };
}
